import { API_BASE_URL } from ".";

const BASE = `${API_BASE_URL}/admin`;

const ENDPOINTS = {
  login: `${BASE}/auth/login`,
  verify: `${BASE}/auth/verify`,
  user: `${BASE}/users`,
  metric: `${BASE}/metrics`,
  template: `${BASE}/templates`,
  render: `${BASE}/render`,
};

export default ENDPOINTS;
